import type { Theme, SxProps } from '@mui/material';

import { Box, Tooltip, ButtonBase } from '@mui/material';

import { useOrganisation } from 'src/organisation';

import { AdaptiveOrganisationLogo } from 'src/components/organisation-logo';

const OrganisationLogoHeader = () => {
  const mediaQuery = 'sm';
  const { organizationName = '', organizationLogo } = useOrganisation();

  const buttonBg: SxProps<Theme> = {
    height: 1,
    zIndex: -1,
    opacity: 0,
    content: "''",
    borderRadius: 1,
    position: 'absolute',
    visibility: 'hidden',
    bgcolor: 'action.hover',
    width: 'calc(100% + 8px)',
    transition: (theme) =>
      theme.transitions.create(['opacity', 'visibility'], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.shorter,
      }),
  };

  return (
    <ButtonBase
      disableRipple
      onClick={() => {}}
      sx={[
        {
          py: 0.5,
          gap: { xs: 0.5, [mediaQuery]: 1 },
          '&::before': buttonBg,
          position: 'relative',
          minWidth: 0,
          overflow: 'hidden',
          maxWidth: {
            xs: 32,
            sm: 140,
            md: 180,
            lg: 220,
            xl: 280,
          },
        },
      ]}
    >
      <AdaptiveOrganisationLogo
        src={organizationLogo}
        name={organizationName}
        height={40}
        minWidth={24}
        maxWidth={120}
      />

      <Tooltip title={organizationName} enterDelay={600} arrow>
        <Box
          component="span"
          sx={{
            typography: 'subtitle2',
            display: { xs: 'none', [mediaQuery]: 'inline-flex' },
            flex: 1,
            minWidth: 0,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
          }}
        >
          {organizationName}
        </Box>
      </Tooltip>
    </ButtonBase>
  );
};

export default OrganisationLogoHeader;
